var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"leftImg"},[_c('img',{attrs:{"src":"/static/image/new/game/back.png","alt":""},on:{"click":function($event){return _vm.$router.back()}}})]),_vm._v(" "),_c('span',{staticClass:"head_text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"right_menu"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2127b4c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = null
// module chunks = 